export { PagerComponent } from './pager.component';
export { PaginationComponent } from './pagination.component';
export { PaginationModule } from './pagination.module';
export { PaginationConfig } from './pagination.config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/pagination/index.js
// module id = 811
// module chunks = 4